import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Employee } from '~/data/employee';
import { EnumListKey, useAllEnums } from '~/data/enums';
import { LegacyFieldReadMode } from '~/legacy-components/LegacyForms';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';
import { getEnumName } from '~/utils/helper';

interface Props {
  employee: Employee;
}

export const LimitedEmployeeData = ({ employee }: Props) => {
  const { t } = useTranslation();
  const { allEnums } = useAllEnums();
  const workContact = employee?.empWorkContact;
  const basicData = employee?.empBasicData;
  const empPosition = employee?.empPosition || employee?.empPositionPending;

  const internalPosition = getEnumName(
    allEnums[EnumListKey.EMPLOYEE_POSITION],
    empPosition.fInternalPositionPosition,
  );

  return (
    <Grid direction={'column'} container>
      <LegacyHeadingWithActions heading={t('laWorkContact')} />
      <LegacyFieldReadMode
        label={t('fEmpPersonNumber')}
        value={basicData?.fEmpPersonNumber}
      />
      <LegacyFieldReadMode label={t('laPosition')} value={internalPosition} />
      <LegacyFieldReadMode
        label={t('fEmpJobTitle')}
        value={empPosition?.fEmpJobTitle}
      />
      <LegacyFieldReadMode
        label={t('fEmpPhoneWork')}
        value={workContact?.fEmpPhoneWork}
      />
      <LegacyFieldReadMode
        label={t('fEmpPhoneMob')}
        value={workContact?.fEmpPhoneMob}
      />
      <LegacyFieldReadMode
        label={t('fEmpEmailWork')}
        value={workContact?.fEmpEmailWork}
      />
    </Grid>
  );
};
